import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import {
  contributorExternalRouteRef,
  readerRouteRef,
  rootRouteRef,
} from './routes';

export const techdocsPlugin = createPlugin({
  id: 'odp-techdocs',
  routes: {
    root: rootRouteRef,
    reader: readerRouteRef,
  },
  externalRoutes: {
    contributor: contributorExternalRouteRef,
  },
});

export const TechdocsPage = techdocsPlugin.provide(
  createRoutableExtension({
    name: 'TechdocsPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);

export const DocsReaderPageComponent = techdocsPlugin.provide(
  createRoutableExtension({
    name: 'DocsReaderPage',
    component: () =>
      import('./pages/DocsReaderPageWithShell/DocsReaderPageWithShell').then(
        m => m.DocsReaderPageEmbedded,
      ),
    mountPoint: readerRouteRef,
  }),
);

export const DocsReaderPageComponentWithShell = techdocsPlugin.provide(
  createRoutableExtension({
    name: 'DocsReaderPage',
    component: () =>
      import('./pages/DocsReaderPageWithShell/DocsReaderPageWithShell').then(
        m => m.DocsReaderPageWithShell,
      ),
    mountPoint: readerRouteRef,
  }),
);
